import { gql } from '@edreamsodigeo/frontend-api-client';
import { api as sectionLocationFragment } from './sectionLocation';

export const api = gql`
  fragment SemSection on SemSection {
    arrivalDate
    departureDate
    duration
    departure {
      ...SectionLocation
    }
    destination {
      ...SectionLocation
    }
    carrier {
      id
      name
    }
    flightCode
    transportType
  }

  ${sectionLocationFragment}
`;
